import * as React from 'react';
import Box from '@mui/material/Box';
import Dialog, {DialogProps} from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {useCallback, useEffect, useRef, useState} from "react";
import AutoMultiRuleDialog from "./AutoMultiRuleDialog"
import InfoIcon from '@mui/icons-material/Info';
import {LightTooltip} from "./MapToolsBase";
import OneRuleDialReturnButtons from "./OneRuleDialReturnButtons";
import OneRuleDialTransfButtons from "./OneRuleDialTransfButtons";
import TextField from '@mui/material/TextField';
import DialogHowToTransform from "./DialogHowToTransform";
import AutoOneRuleDialog from "./AutoOneRuleDialog";
import IceButton from "../../components/Button";


export default function OneRuleDialog(props: any) {

    const {
        open,
        setOpen,
        dialRule,
        setDialRule,
        condObj,
        setCondObj,
        handleChange,
        mapData,
        valueConditions,
        currentRules,
        index
    } = props


    const templatesTooltip: any = [
        '{value} – value only', <br/>,
        '{name} – feature name', <br/>,
        '{unit} – feature unit', <br/>,
        '{loc-value} – feature unit', <br/>,
        <br/>, '- use either one or multiple items', <br/>,
        '- put any delimiter when multiple items'
    ]

    const [openTransformHowto, setOpenTransformHowto] = useState<boolean>(false)

    function handleDialRuleChange(value: string, name: string) {

        setDialRule((prev: any) => {
            return {...prev, [name]: value}
        })
    }


    function handleSave() {
        // console.log('Save rule')
        currentRules[index] = dialRule
        setCondObj(JSON.parse(JSON.stringify(condObj)))
        setOpen(false)

    }


    const handleClose = (event: any, reason: any) => {
        // prevents closing when clicked outside of the dialog
        if (reason && reason === "backdropClick") {
            return;
        }
        setOpen(false)
    }

    return (

        <>
            <Dialog
                fullWidth
                maxWidth='xl'
                // fullScreen
                open={open}
                onClose={handleClose}
            >
                <DialogTitle sx={{borderBottom: "1px #cccccc solid", padding: "12px 24px", fontSize: "1.15rem"}}>Feature Mapping Rule details and settings</DialogTitle>
                <DialogContent>
                    {/*<DialogContentText>*/}
                    {/*    You can set my maximum width and whether to adapt or not.*/}
                    {/*</DialogContentText>*/}

                    <Box
                        noValidate
                        component="form"
                        sx={{
                            // height: 100
                            minHeight: '60vh',
                            // display: 'flex',
                            // flexDirection: 'column',
                            // m: 'auto',
                            // width: 'fit-content',
                        }}

                    >

                        <div className="rule-dialog-container">

                            <div className="rule-dialog-top-block">
                                {/* Field Type */}
                                <div className="featmap-trg-subcont">
                                    <div className="field-label">Field type</div>
                                    <select
                                        id="fieldType"
                                        name="fieldType"
                                        disabled
                                        value={dialRule.fieldType}
                                        // onChange={(event) => handleChange(event.target.value, event.target.name)}
                                    >
                                        <option value="feature">Feature</option>
                                    </select>
                                </div>

                                {/* Field Name */}
                                <div className="featmap-trg-subcont">
                                    <div className="field-label">Field name</div>
                                    {/* Field Name and Field ID */}
                                    <div>
                                        <AutoOneRuleDialog
                                            name="fieldName"
                                            fieldType={dialRule.fieldType}
                                            mapData={mapData}
                                            val={dialRule.fieldName}
                                            dialRule={dialRule}
                                            setDialRule={setDialRule}
                                            condObject={condObj}
                                        />
                                    </div>
                                </div>

                            </div>

                            <div className="rule-dialog-value-block">
                                {/* Field Name */}
                                <div className="featmap-trg-subcont">
                                    <div className="field-label">Value condition</div>
                                    <select
                                        id="valueCondition"
                                        name="valueCondition"
                                        value={dialRule.valueCondition}
                                        onChange={(event) => handleDialRuleChange(event.target.value, event.target.name)}
                                    >
                                        {valueConditions}
                                    </select>
                                </div>


                                {/* Values or Textline */}
                                <div className="featmap-trg-subcont">
                                    <div className="field-label">Values</div>
                                    <AutoMultiRuleDialog
                                        name="values"
                                        mapData={mapData}
                                        val={dialRule.values}
                                        dialRule={dialRule}
                                        setDialRule={setDialRule}
                                        condObject={condObj}
                                    />
                                </div>

                            </div>


                            <div className="rule-dialog-return-block">
                                <div className="field-label">Use as:</div>
                                <select
                                    id="useAS"
                                    name="useAS"
                                    value={dialRule.useAS}
                                    onChange={(event) => handleDialRuleChange(event.target.value, event.target.name)}
                                >
                                    <option value="condition">condition</option>
                                    <option value="return">return</option>
                                </select>

                                {dialRule.useAS === "return" &&
                                    <>
                                        <div className="field-label" style={{marginLeft: '20px'}}>Return template:</div>
                                        <div className="rule-dialog-return-tmpl-block">
                                            <input
                                                id="return-template"
                                                name="returnTemplate"
                                                className="regular-input"
                                                value={dialRule.returnTemplate}
                                                onChange={(event) => handleDialRuleChange(event.target.value, event.target.name)}
                                                // onMouseOver={() => setTmplInputClicked(true)}
                                                // onMouseOut={() => setTmplInputClicked(false)}
                                                // onMouseLeave={() => setTmplInputClicked(false)}
                                            />
                                            <OneRuleDialReturnButtons
                                                dialRule={dialRule}
                                                setDialRule={setDialRule}
                                            />
                                        </div>

                                        <div style={{marginLeft: "-3px"}}>
                                            <LightTooltip title={templatesTooltip}>
                                                <InfoIcon
                                                    fontSize="small"
                                                    color="action"
                                                />
                                            </LightTooltip>
                                        </div>
                                    </>
                                }

                            </div>


                            {dialRule.useAS === "return" &&
                                <div className="rule-dialog-transformation-block">
                                    <div className="field-label">Flexible transformations:</div>

                                    <div className="rule-dialog-return-tmpl-block">
                                        <TextField
                                            id="transformRules"
                                            // label="Multiline"
                                            name="transformRules"
                                            sx={{"& .MuiOutlinedInput-input": {
                                                    color: "#464d53 !important"}
                                            }}
                                            multiline
                                            rows={3}
                                            // maxRows={4}
                                            // defaultValue="Default Value"
                                            value={dialRule.transformRules}
                                            onChange={(event) => handleDialRuleChange(event.target.value, event.target.name)}
                                        />
                                        <OneRuleDialTransfButtons
                                            dialRule={dialRule}
                                            setDialRule={setDialRule}
                                        />
                                    </div>

                                    <>
                                        <DialogHowToTransform
                                            open={openTransformHowto}
                                            setOpen={setOpenTransformHowto}
                                        />
                                        <LightTooltip title="How-to-use and examples">
                                            <InfoIcon
                                                fontSize="small"
                                                color="action"
                                                onClick={() => setOpenTransformHowto(true)}
                                                sx={{cursor: "pointer"}}
                                            />
                                        </LightTooltip>
                                    </>
                                </div>
                            }


                        </div>
                    </Box>

                </DialogContent>

                <DialogActions style={{marginBottom: "15px", marginRight: "10px"}}>
                    <IceButton type="primary" text="Save" onclick={handleSave} />
                    <IceButton type="delete" text="Cancel" onclick={(event: any) => handleClose(event, 'cancelButton')} />
                </DialogActions>
            </Dialog>

        </>
    );
}